import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth, homeForRole } from '../context/AuthContext';
import { Logo } from '../components/commerce/Logo';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const redirect = params.get('redirect');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const res = await register(form.name, form.email, form.password, form.phone);
    setLoading(false);
    if (res.ok) navigate(redirect || homeForRole(res.user.role));
    else setError(res.error);
  };

  const field = (key, props) => (
    <input
      data-testid={`register-${key}`}
      value={form[key]}
      onChange={(e) => setForm({ ...form, [key]: e.target.value })}
      className="h-10 w-full rounded-sm border border-kelate-line bg-kelate-bg px-3 text-sm outline-none focus:border-kelate-wood"
      {...props}
    />
  );

  return (
    <div data-testid="register-page" className="mx-auto flex max-w-[1280px] items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm rounded-3xl bg-kelate-surface p-8 shadow-[0_1px_4px_rgba(81,68,55,0.08)]">
        <div className="text-center">
          <Logo className="mx-auto h-10" testId="register-logo" />
          <h1 className="mt-2 text-base font-semibold text-kelate-ink">Create your account</h1>
          <p className="mt-1 text-xs text-kelate-soft">Browse freely — an account is only needed to order, follow or save.</p>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-3">
          {field('name', { placeholder: 'Full name', required: true })}
          {field('email', { placeholder: 'Email', type: 'email', required: true })}
          {field('phone', { placeholder: 'Phone (for delivery updates)', required: true })}
          {field('password', { placeholder: 'Password (min 6 characters)', type: 'password', required: true, minLength: 6 })}
          {error && <p className="text-xs text-kelate-red" data-testid="register-error">{error}</p>}
          <button data-testid="register-submit" disabled={loading} className="h-10 w-full rounded-sm bg-kelate-darkwood text-sm font-medium text-kelate-surface hover:bg-kelate-wood disabled:opacity-50">
            {loading ? 'Creating...' : 'Create Account'}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-kelate-soft">
          Already have an account? <Link to={`/account/login${redirect ? `?redirect=${redirect}` : ''}`} data-testid="go-login" className="font-medium text-kelate-wood hover:text-kelate-darkwood">Log in</Link>
        </p>
      </div>
    </div>
  );
}
